<template>
  <div class="app app-contents columns">
    <div v-if="loading" class="spinner-container">
      <woot-loading-state :message="$t('EMBED_VIEW.LOADING')" />
    </div>
    <iframe
      v-else-if="isEmbeddable"
      :key="frameKey"
      ref="typebotIframe"
      :src="computedUrl"
      height="100%"
      scrolling="true"
      width="100%"
      frameborder="0"
    />
    <div v-else class="spinner-container">
      <h2>{{ $t('EMBED_VIEW.UNABLE_TO_DISPLAY_TITLE') }}</h2>
      <p>{{ errorMessage || $t('EMBED_VIEW.NOT_EMBEDDABLE') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {},
  data() {
    return {
      loading: true,
      isEmbeddable: true,
      errorMessage: '',
      frameKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      dashboardApps: 'dashboardApps/getRecords',
      selectedUrl: 'dashboardApps/getSelectedUrl',
    }),
    computedUrl() {
      if (this.selectedUrl) {
        return this.selectedUrl;
      }
      const records = Array.isArray(this.dashboardApps)
        ? this.dashboardApps
        : [];
      const firstPage = records
        .filter(item => Array.isArray(item.content))
        .map(item => item.content.find(c => c && c.type === 'frameFull'))
        .find(c => c && c.url);
      return firstPage ? firstPage.url : null;
    },
  },
  watch: {
    computedUrl: {
      immediate: false,
      handler(newUrl, oldUrl) {
        if (newUrl && newUrl !== oldUrl) {
          this.validateAndShow(newUrl);
        }
      },
    },
  },
  async created() {
    try {
      await this.$store.dispatch('dashboardApps/get');
      const url = this.computedUrl;
      if (!url) {
        this.isEmbeddable = false;
        this.errorMessage = this.$t('EMBED_VIEW.NO_URL_AVAILABLE');
        return;
      }
      await this.validateAndShow(url);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async validateAndShow(url) {
      this.loading = true;
      try {
        const { embeddable } = await this.$store.dispatch(
          'dashboardApps/checkEmbeddable',
          url
        );
        this.isEmbeddable = !!embeddable;
        if (!this.isEmbeddable) {
          this.errorMessage = this.$t('EMBED_VIEW.NOT_EMBEDDABLE');
        } else {
          this.errorMessage = '';
          this.frameKey += 1; // força recriação do iframe
        }
      } catch (error) {
        this.isEmbeddable = false;
        this.errorMessage =
          error?.message || this.$t('EMBED_VIEW.ERROR_CHECKING_URL');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.app {
  display: flex;
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}
.page-container {
  flex: 1;
  height: 100vh;
  overflow-y: auto;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  width: 100%;
  flex-direction: column;
  text-align: center;
}

.spinner-container h2 {
  font-size: 1.5rem;
  line-height: 1.25;
  margin: 0.25rem 0 0;
}

.spinner-container p {
  margin: 0.25rem 0 0;
}

.spinner {
  width: 32px;
  height: 32px;
  /* border: 4px solid #ccc;
  border-top: 4px solid #333;
  border-radius: 50%; */
  animation: spin 0.8s linear infinite;
  /* margin-top: 10px; */
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
